// Define Action Types
export const FETCH_ESCALATION_POLICIES_REQUESTED = 'FETCH_ESCALATION_POLICIES_REQUESTED';
export const FETCH_ESCALATION_POLICIES_COMPLETED = 'FETCH_ESCALATION_POLICIES_COMPLETED';
export const FETCH_ESCALATION_POLICIES_ERROR = 'FETCH_ESCALATION_POLICIES_ERROR';

// Define Actions
export const getEscalationPoliciesAsync = () => ({
  type: FETCH_ESCALATION_POLICIES_REQUESTED,
});
